// extracted by mini-css-extract-plugin
module.exports = {"flag":"lietuva_flag__E66IW","heading":"lietuva_heading__N0zBk","eggRotate":"lietuva_eggRotate__bpn2x","eggTop":"lietuva_eggTop__cHwra"};